import React, { useEffect, useState } from 'react';
import { Box } from '@mantine/core';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { BottomNav } from './components/BottomNav';
import { Dashboard } from './pages/Dashboard';
import { PropertyDetails } from './pages/PropertyDetails';
import { ConstructionTracker } from './pages/ConstructionTracker';
import { FinancialLedger } from './pages/FinancialLedger';
import { SupportTickets } from './pages/SupportTickets';
import { ProjectDiscovery } from './pages/ProjectDiscovery';
import { ReferralTracker } from './pages/ReferralTracker';
import { Login } from './pages/Login';
type NavItem = 'home' | 'properties' | 'payments' | 'support' | 'more';
type Screen = 'dashboard' | 'property-details' | 'construction' | 'ledger' | 'support' | 'discovery' | 'referral';
function AppContent() {
  const {
    isRTL
  } = useLanguage();
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('isAuthenticated') === 'true';
  });
  const [activeNav, setActiveNav] = useState<NavItem>('home');
  const [currentScreen, setCurrentScreen] = useState<Screen>('dashboard');
  const [selectedPropertyId, setSelectedPropertyId] = useState<string | null>(null);
  useEffect(() => {
    localStorage.setItem('isAuthenticated', String(isAuthenticated));
  }, [isAuthenticated]);
  const handleNavigation = (item: NavItem) => {
    setActiveNav(item);
    switch (item) {
      case 'home':
        setCurrentScreen('dashboard');
        break;
      case 'properties':
        setCurrentScreen('construction');
        break;
      case 'payments':
        setCurrentScreen('ledger');
        break;
      case 'support':
        setCurrentScreen('support');
        break;
      case 'more':
        setCurrentScreen('discovery');
        break;
    }
  };
  const handlePropertyClick = (propertyId: string) => {
    setSelectedPropertyId(propertyId);
    setCurrentScreen('property-details');
  };
  const handleBackFromProperty = () => {
    setCurrentScreen('dashboard');
    setActiveNav('home');
  };
  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };
  const renderScreen = () => {
    switch (currentScreen) {
      case 'dashboard':
        return <Dashboard onPropertyClick={handlePropertyClick} onViewAllProperties={() => setCurrentScreen('construction')} data-id="element-0" />;
      case 'property-details':
        return <PropertyDetails propertyId={selectedPropertyId || undefined} onBack={handleBackFromProperty} data-id="element-1" />;
      case 'construction':
        return <ConstructionTracker data-id="element-2" />;
      case 'ledger':
        return <FinancialLedger data-id="element-3" />;
      case 'support':
        return <SupportTickets data-id="element-4" />;
      case 'discovery':
        return <ProjectDiscovery data-id="element-5" />;
      case 'referral':
        return <ReferralTracker data-id="element-6" />;
      default:
        return <Dashboard data-id="element-7" />;
    }
  };
  if (!isAuthenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} data-id="element-8" />;
  }
  return <Box style={{
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    maxWidth: 428,
    margin: '0 auto',
    position: 'relative',
    direction: isRTL ? 'rtl' : 'ltr'
  }} data-id="element-9">
      {/* Main Content */}
      <Box p="md" style={{
      height: 'calc(100vh - 64px)',
      paddingBottom: 80
    }} data-id="element-10">
        {renderScreen()}
      </Box>

      {/* Bottom Navigation */}
      <BottomNav active={activeNav} onNavigate={handleNavigation} data-id="element-11" />

      {/* Quick Access to Referral (from More menu) */}
      {currentScreen === 'discovery' && <Box onClick={() => setCurrentScreen('referral')} style={{
      position: 'fixed',
      bottom: 150,
      right: isRTL ? 'auto' : 20,
      left: isRTL ? 20 : 'auto',
      backgroundColor: '#1a2332',
      color: 'white',
      padding: '12px 16px',
      borderRadius: 12,
      cursor: 'pointer',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      fontSize: 14,
      fontWeight: 600
    }} data-id="element-12">
          🎁 Referral Program
        </Box>}
    </Box>;
}
export function App() {
  return <LanguageProvider data-id="element-13">
      <AppContent data-id="element-14" />
    </LanguageProvider>;
}